import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { createEntitiesSelector } from '../../../../entity/entities.reducer';
import { EntityTypes } from '../../../../entity/entity-types';
import { EntityState } from '../../../../entity/entity.reducer';
import { Entities } from '../../../../entity/entities';
import { createSymfonyTotalCountSelector } from '../../../../symfony/list/selectors/list.selectors';
import { ServiceProjectPart } from '../models/part';
import { getServiceProjectPartListState } from '../part.reducer';

const createState = (id: IdType) => createSelector(
  getServiceProjectPartListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateById = (id: IdType) => createListStateIdsSelector(createState(id));

export const createServiceProjectPartListData = (id: IdType) => createSelector(
  createStateById(id),
  createEntitiesSelector([
    EntityTypes.projectPart
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.projectPart]], entities) as ServiceProjectPart[]
);

export const createServiceProjectPartListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createServiceProjectPartListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createServiceProjectPartListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createServiceProjectPartListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createServiceProjectPartListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
